import { OnboardingConsts } from '@shared/constants';

export function getProjectOnboardingView(projectId: string): string {
  return `${OnboardingConsts.ProjectOnboarding}:${projectId}`;
}
